.readOnly input {
	color: var(--ds-text-disabled, var(--adg3-color-N70));
}
